import { Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '@workspace/public-utils'

import StarLayout from './components/layout/StarLayout'
import StarHomePage from './pages/StarHomePage'

import LotteryResultsPage from '@workspace/public-ui/pages/LotteryResultsPage'
import LotteryResultDetailPage from '@workspace/public-ui/pages/LotteryResultDetailPage'
import AnalysisHomePage from '@workspace/public-ui/pages/AnalysisHomePage'
import HotColdAnalysisPage from '@workspace/public-ui/pages/analysis/HotColdAnalysisPage'
import OddEvenAnalysisPage from '@workspace/public-ui/pages/analysis/OddEvenAnalysisPage'
import NumberSumAnalysisPage from '@workspace/public-ui/pages/analysis/NumberSumAnalysisPage'
import ReappearanceAnalysisPage from '@workspace/public-ui/pages/analysis/ReappearanceAnalysisPage'
import LuckyNumberPage from '@workspace/public-ui/pages/analysis/LuckyNumberPage'
import ConsecutiveNumbersPage from '@workspace/public-ui/pages/analysis/ConsecutiveNumbersPage'
import StarSubscriptionPlansPage from './pages/StarSubscriptionPlansPage'
import FAQPage from '@workspace/public-ui/pages/FAQPage'
import StarLoginPage from './pages/StarLoginPage'
import DashboardPage from '@workspace/public-ui/pages/dashboard/DashboardPage'
import ProfilePage from '@workspace/public-ui/pages/dashboard/ProfilePage'
import MyNumbersPage from '@workspace/public-ui/pages/dashboard/MyNumbersPage'
import SubscriptionPage from '@workspace/public-ui/pages/dashboard/SubscriptionPage'
import AuthCallback from '@workspace/public-ui/components/auth/AuthCallback'
import PrivateRoute from '@workspace/public-ui/components/auth/PrivateRoute'
import DashboardLayout from '@workspace/public-ui/components/layout/DashboardLayout'
import AnnouncementModal from '@workspace/public-ui/components/AnnouncementModal'
import ScrollToTop from '@workspace/public-ui/components/ScrollToTop'
import TermsPage from '@workspace/public-ui/pages/legal/TermsPage'
import PrivacyPage from '@workspace/public-ui/pages/legal/PrivacyPage'
import TermsConsentPage from '@workspace/public-ui/pages/TermsConsentPage'

function StarApp() {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <AnnouncementModal />
      <Routes>
        {/* Public Routes — using Star-specific layout */}
        <Route path="/" element={<StarLayout />}>
          <Route index element={<StarHomePage />} />
          <Route path="results" element={<LotteryResultsPage />} />
          <Route path="results/:roundNumber" element={<LotteryResultDetailPage />} />
          <Route path="analysis" element={<AnalysisHomePage />} />
          <Route path="analysis/hot-cold" element={<HotColdAnalysisPage />} />
          <Route path="analysis/odd-even" element={<OddEvenAnalysisPage />} />
          <Route path="analysis/number-sum" element={<NumberSumAnalysisPage />} />
          <Route path="analysis/reappearance" element={<ReappearanceAnalysisPage />} />
          <Route path="analysis/lucky-number" element={<LuckyNumberPage />} />
          <Route path="analysis/consecutive-numbers" element={<ConsecutiveNumbersPage />} />
          <Route path="plans" element={<StarSubscriptionPlansPage />} />
          <Route path="faq" element={<FAQPage />} />
        </Route>

        {/* Auth Routes — login only (no register) */}
        <Route path="/auth/login" element={<StarLoginPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />

        {/* Public Terms Consent Page - accessible via SMS link */}
        <Route path="/plans/:consentPath" element={<TermsConsentPage />} />

        {/* Protected Dashboard Routes — using Star-specific layout */}
        <Route path="/dashboard" element={<PrivateRoute />}>
          <Route path="" element={<StarLayout />}>
            <Route index element={<DashboardLayout><DashboardPage /></DashboardLayout>} />
            <Route path="profile" element={<DashboardLayout><ProfilePage /></DashboardLayout>} />
            <Route path="numbers" element={<DashboardLayout><MyNumbersPage /></DashboardLayout>} />
            <Route path="subscription" element={<DashboardLayout><SubscriptionPage /></DashboardLayout>} />
          </Route>
        </Route>
      </Routes>
    </ThemeProvider>
  )
}

export default StarApp
